import { ReactNode, useId } from "react";

/** A titled part of the run page, such as the summary or the suggested changes. */
export const PlanSection = ({
  title,
  description,
  actions,
  children,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className="flex min-w-0 flex-col gap-3"
    >
      <div className="flex flex-wrap items-end gap-x-4 gap-y-1">
        <div className="flex min-w-0 flex-[1_1_240px] flex-col gap-0.5">
          <h2
            id={headingId}
            className="m-0 text-[18px] font-semibold leading-[1.35] text-black/[.87]"
          >
            {title}
          </h2>
          {description && <div className="text-black/60">{description}</div>}
        </div>
        {actions && <div className="ml-auto shrink-0">{actions}</div>}
      </div>
      {children}
    </section>
  );
};
